// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27><circle cx=%2710%27 cy=%2710%27 r=%2710%27 fill=%27grey%27 opacity=%270.75%27 /></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Great+Vibes&family=Italiana&family=Italianno&family=La+Belle+Aurore);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family: sans-serif;
  text-align: center;
}

#root,
body,
canvas {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  background-color: #111111;

  /* Make a grey dot cursor */
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      5 5,
    auto;
}

html {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,yBAAyB;;EAEzB,2BAA2B;EAC3B;;QAEM;AACR;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Great+Vibes&family=Italiana&family=Italianno&family=La+Belle+Aurore\");\n\n.App {\n  font-family: sans-serif;\n  text-align: center;\n}\n\n#root,\nbody,\ncanvas {\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  margin: 0;\n  background-color: #111111;\n\n  /* Make a grey dot cursor */\n  cursor: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><circle cx='10' cy='10' r='10' fill='grey' opacity='0.75' /></svg>\")\n      5 5,\n    auto;\n}\n\nhtml {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
